import debounce from 'lodash/debounce'
import { AppUtil, UIUtil } from 'kuaidong-lib'

export class FileExportService {
  static exportFile(api: Function, ...params: any[]) {
    return debounce(
      async () => {
        try {
          UIUtil.showLoading()

          const url = await api(...params)

          UIUtil.hideLoading()

          if (url) {
            const result = await AppUtil.downloadAndShareByUrl(url)
            if (result && result.version) {
              UIUtil.showToast(`当前版本太低，请先升级到${result.version}及以上版本～`)
            }
          }
        } catch (e) {
          e.text && UIUtil.checkFailed(e.text)
        }
      },
      2000,
      { leading: true, trailing: false }
    )
  }
}
